import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const BanknoteIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 22 22" sx={{ height: '22px', width: '22px', ...sx }} {...props}>
      <path
        d="M5.50016 10.0832V13.7498M16.5002 8.24984V11.9165M15.5835 3.6665C17.8281 3.6665 19.0422 4.01003 19.6463 4.27649C19.7267 4.31198 19.7669 4.32972 19.883 4.44051C19.9526 4.50692 20.0796 4.70178 20.1123 4.79225C20.1668 4.94318 20.1668 5.02568 20.1668 5.19068V15.0434C20.1668 15.8764 20.1668 16.2929 20.0419 16.507C19.9148 16.7248 19.7923 16.8261 19.5544 16.9098C19.3206 16.992 18.8486 16.9013 17.9047 16.72C17.2439 16.593 16.4603 16.4998 15.5835 16.4998C12.8335 16.4998 10.0835 18.3332 6.41683 18.3332C4.17218 18.3332 2.95812 17.9896 2.35406 17.7232C2.27361 17.6877 2.23339 17.67 2.1173 17.5592C2.04771 17.4928 1.92069 17.2979 1.88801 17.2074C1.8335 17.0565 1.8335 16.974 1.8335 16.809L1.8335 6.95629C1.8335 6.12325 1.8335 5.70673 1.95842 5.49264C2.08549 5.27485 2.20804 5.17361 2.44588 5.08991C2.6797 5.00763 3.15169 5.09832 4.09567 5.2797C4.7564 5.40665 5.54002 5.49984 6.41683 5.49984C9.16683 5.49984 11.9168 3.6665 15.5835 3.6665ZM13.2918 10.9998C13.2918 12.2655 12.2658 13.2915 11.0002 13.2915C9.73451 13.2915 8.7085 12.2655 8.7085 10.9998C8.7085 9.73418 9.73451 8.70817 11.0002 8.70817C12.2658 8.70817 13.2918 9.73418 13.2918 10.9998Z"
        stroke={
          props.color === 'warning' ? 'rgba(36, 176, 126, 1)' : props.color === 'secondary' ? '#24B07E' : '#14191F'
        }
        strokeOpacity="0.4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill={'transparent'}
      />
    </SvgIcon>
  );
};
export default BanknoteIcon;
